import { render, staticRenderFns } from "./CardsContainer.vue?vue&type=template&id=be76ada4"
import script from "./CardsContainer.vue?vue&type=script&lang=ts"
export * from "./CardsContainer.vue?vue&type=script&lang=ts"
import style0 from "./CardsContainer.vue?vue&type=style&index=0&id=be76ada4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports